/* 🤖 this file was generated by script */
export const wiconType01 = {
  name: 'type_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7c0-.93 0-1.4.15-1.77a2 2 0 011.08-1.08C5.6 4 6.07 4 7 4h10c.93 0 1.4 0 1.77.15a2 2 0 011.08 1.08C20 5.6 20 6.07 20 7M9 20h6M12 4v16"/></svg>`,
};
